import React, { useEffect, useState, useLayoutEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
  activeFormatter,
  showConfirmDialog,
  formatDate,
  lockedFormatter,
  showDeleteDialog,
  useForceUpdate,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Button, Col, Row } from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import {
  addMenuFav,
  fetchIdMenuFav,
  fetchMenu,
  fetchMenuModal,
  selectDataMenuModal,
  selectIdMenuFav,
  selectLoading,
} from "../../pages/menu/menuSlice";
import SVG from "react-inlinesvg";
import { selectMe } from "../Auth/_redux/authRedux";
import { CardBody, Card } from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";

export const QuickLink = ({
  tableData,
  setTableData,
  listMenu,
  setListMenu,
  tableData2,
  setTableData2,
  force,
  setForce,
}) => {
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const history = useHistory();
  const dataMenu = useSelector(selectDataMenuModal);
  const dataIdMenuFav = useSelector(selectIdMenuFav);
  const dataMe = useSelector(selectMe);
  const forceUpdate = useForceUpdate();
  const { SearchBar } = Search;

  const columns = [
    {
      dataField: "menu_name",
      text: "Menu",
    },
  ];

  const columnsMove = [
    {
      dataField: "menu_name",
      text: "Menu",
    },
  ];

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowsMove, setSelectedRowsMove] = useState([]);

  const onSelectRow = {
    mode: "checkbox",
    onSelectAll: (status) => {
      if (status === true) {
        setSelectedRows(tableData);
      } else {
        setSelectedRows([]);
        return false;
      }
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
        }
      }
    },
  };

  const onSelectRowMove = {
    mode: "checkbox",
    onSelectAll: (status) => {
      if (status === true) {
        setSelectedRowsMove(tableData2);
      } else {
        setSelectedRowsMove([]);
        return false;
      }
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRowsMove([...selectedRowsMove, row]);
      } else {
        const index = selectedRowsMove.indexOf(row);
        if (index > -1) {
          selectedRowsMove.splice(index, 1);
        }
      }
    },
  };

  const handleMove = () => {
    const newData = tableData.filter(
      (item) => !selectedRows.some((t) => t.menu_id === item.menu_id)
    );
    setTableData2([...tableData2, ...selectedRows]);
    setTableData(newData);
    setSelectedRows([]);
    setSelectedRowsMove([]);
    setForce(true);

    forceUpdate();
  };

  // handle back

  const handleBack = () => {
    const newData = tableData2.filter(
      (item) => !selectedRowsMove.some((t) => t.menu_id === item.menu_id)
    );

    setTableData([...tableData, ...selectedRowsMove]);
    setTableData2(newData);
    setSelectedRowsMove([]);
    setSelectedRows([]);
    setForce(true);
    forceUpdate();
  };

  const handleSave = async () => {
    const params = tableData2.map((item) => {
      return {
        menu_id: item.menu_id,
        user_id: dataMe.user_id,
      };
    });

    console.log(listMenu, "listMenu");

    try {
      const response = await dispatch(addMenuFav(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  console.log(tableData, "tableData");
  console.log(tableData2, "TableData2");

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardBody>
          {" "}
          <div>
            <Row className="mt-8">
              <Col xs={12} sm={3} md={5} lg={5}>
                <div className="border-m ">
                  <h4>Available Menus</h4>

                  <ToolkitProvider
                    keyField="menu_id"
                    data={tableData}
                    columns={columns}
                    search
                  >
                    {(props) => (
                      <div>
                        <SearchBar {...props.searchProps} />
                        <hr />
                        <div className="table-container">
                          <BootstrapTable
                            wrapperClasses="table-responsive"
                            classes="table table-head-custom table-vertical-center overflow-hidden rounded "
                            bootstrap4
                            selectRow={onSelectRow}
                            {...props.baseProps}
                          />
                        </div>
                      </div>
                    )}
                  </ToolkitProvider>
                </div>
              </Col>
              <Col sm={1} className="mt-10 justify-content-center">
                <Row className="m-0  p-0 justify-content-center">
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm  justify-content-center mb-5 "
                    onClick={handleMove}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Navigation/Angle-right.svg"
                        )}
                      />
                    </span>
                  </div>
                </Row>
                <Row className="m-0  p-0 justify-content-center">
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm  mb-4  justify-content-center  mt-5  "
                    onClick={handleBack}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Navigation/Angle-left.svg"
                        )}
                      />
                    </span>
                  </div>
                </Row>
              </Col>
              <Col xs={12} sm={3} md={5} lg={5}>
                <div className="border-m">
                  <h4>Selected Menus</h4>

                  <ToolkitProvider
                    keyField="menu_id"
                    data={tableData2}
                    columns={columnsMove}
                    search
                  >
                    {(props) => (
                      <div>
                        <SearchBar {...props.searchProps} />
                        <hr />
                        <div className="table-container">
                          <BootstrapTable
                            wrapperClasses="table-responsive"
                            classes="table table-head-custom table-vertical-center overflow-hidden rounded "
                            bootstrap4
                            selectRow={onSelectRowMove}
                            {...props.baseProps}
                          />
                        </div>
                      </div>
                    )}
                  </ToolkitProvider>
                </div>
              </Col>
            </Row>
            <Row className="mt-6 justify-content-end">
              <Button variant="primary" onClick={handleSave}>
                Save
              </Button>
            </Row>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
